module.exports = __webpack_public_path__ + "img/tradexc_vertical_logo.47b35dd7.png";